module.exports = __webpack_public_path__ + "img/alert_fan_gray.bf67ad6d.svg";